<template>
  <accordion-section
    :open="section === 2"
    :valid="!!businessName"
    @selected="$emit('openSection', 2)"
  >
    <template #heading>
      Business Name
    </template>

    <custom-input
      v-model="businessName"
      :validation-errors="validationErrors['title']"
      label="Enter your business name"
      placeholder="Enter your business name"
      :disabled="!canEditLocation"
    />

    <div class="recommendations">
      <span>Recommendations</span>
      <ul>
        <li>Use the same business name as on your signs, business cards, and legal documents.</li>
        <li>
          Do <strong>NOT</strong> spam your business name with cities, search terms, taglines, or anything else.
          It is against Google’s terms of service and could lead to listing problems or suspension in the future.
        </li>
      </ul>
    </div>
  </accordion-section>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import AccordionSection from "../items/AccordionSection";
import CustomInput from "../../../../../views/reports/components/global/forms/CustomInput";

export default {
  components: {
    CustomInput,
    AccordionSection
  },
  props: {
    section: {
      type: Number,
      required: true,
    },
  },
  emits: ['openSection'],
  computed: {
    ...mapGetters('user', [
        'canEditLocation',
    ]),
    ...mapGetters('businessProfile', [
      'validationErrors',
    ]),
    businessName: {
      get() {
        return this.$store.getters['businessProfile/title'];
      },
      set(value) {
        this.updateTitle(value);
      }
    }
  },
  methods: {
    ...mapMutations('editListing', [
      'setSelectedSection',
    ]),
    ...mapActions('businessProfile', [
      'updateTitle',
    ])
  },
}
</script>
